import { ConnectedPosition } from '@angular/cdk/overlay';

export const OVERLAY_POSITIONS = {
  // Primary positions
  BOTTOM_LEFT: {
    originX: 'start',
    originY: 'bottom',
    overlayX: 'start',
    overlayY: 'top',
  } as ConnectedPosition,

  BOTTOM_RIGHT: {
    originX: 'end',
    originY: 'bottom',
    overlayX: 'end',
    overlayY: 'top',
  } as ConnectedPosition,

  TOP_LEFT: {
    originX: 'start',
    originY: 'top',
    overlayX: 'start',
    overlayY: 'bottom',
  } as ConnectedPosition,

  TOP_RIGHT: {
    originX: 'end',
    originY: 'top',
    overlayX: 'end',
    overlayY: 'bottom',
  } as ConnectedPosition,
};
